<app-jarvis-ui
  (SelectionChanged)="SelectionChanged($event)"
  (ActionClick)="ActionClick($event)"
  (OtherActionClick)="onOtherActionClick($event)"
  (logout)="logout()"
  (devicesClick)="onDevicesClick()"
  [User]="user"
  [Menus]="menus"
  [ImageUrl]="imageUrl"
  [CoopName]="CoopName"
  [DevicesUrl]="devicesUrl"
  name="jarvisMenu">
</app-jarvis-ui>
<input name = "tokeninput" value= {{currentUser.token}} type="hidden" />
<input name = "applicationId" value="8c481d582cc5472f99dc78980c2cc308" type="hidden" />

<map [ilot]="currentOrders"  [type]="'plot'" ></map>

<console-window  *ngIf="isUserAuthenticated" [ilot]="currentOrders"  [opened] = "consoleDialogOpened" [SelectedCultivations]="SelectedCultivations" (DialogClosed)="ConsoleDialogClosed($event)" (EmitedEventOnExportDevice)="onEventOnExportPopin($event)"></console-window>
<export-window  [opened] = "exportDialogOpened" [ilot]="currentOrders" [FilterPrestationsTypes]="exportPrestationTypes" [PrevPrecoPrintModels] ="PrevPrecoPrinPdfModels" [ModulationPrecosTypes]="ModPrecosTypes" [IntersModePrecoTypes]="IntersModePrecoTypes" [DiagnosticPrestTypes]="DiagnosticPrestTypes" [ExtraPrintModels]="ExtraPrintPdfModels"  (DialogClosed)="ExportDialogClosed($event)" ></export-window>
<devices-window *ngIf="isUserAuthenticated" [opened]="devicesDialogOpened" [devicesUrl]="devicesUrl" (DialogClosed)="DevicesDialogClosed($event)"></devices-window>

<export-connected-states *ngIf="isUserAuthenticated"  [opened] = "popinConnectedStatesOpened" (DialogClosed)="popinConnectedStatesClosed($event)"></export-connected-states>

<duplicate-tech-preconisation (DialogClosed)="onDuplicateTechPrecoDialogClosed($event)"></duplicate-tech-preconisation>
<update-farmer-previs    (DialogClosed)="onFarmerPrevisUpdateDialogClosed($event)" ></update-farmer-previs>
